export default {"src":"/_next/static/media/skillz-logo-white.98f503a6.svg","height":58,"width":89,"blurWidth":0,"blurHeight":0};